export default function () {
	return {
		favorite: 'all',
		origin: 'podcasts',
		playlist: [],
		progress: 'all',
		search: '',
		loading: false,
		selected_areas: {
			value: 'all'
		},
		selected_groups: {
			value: 'all'
		},
		selected_tags: {
			value: 'all'
		},
		trail_id: null,
		podcast_id: null
	}
}
